// @ts-nocheck

import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import useMergeProps from '../../../../hooks/useMergeProps';
import RoutesRedirectionFactory from '../../../../utils/routes/RoutesRedirectionFactory';
import { selectIsBoomEnabled } from '../../selectors/runtime.selector';
import { selectBoomUserStatus } from '../../selectors/user/userPrimary.selector';
import { BoomUserStatuses } from '../../types/user';

import BoomEnrollment from './BoomEnrollment';
import selectBoomEnrollmentProps from './BoomEnrollment.selector';

type BoomEnrollmentContainerProps = {
  className?: string;
};

const BoomEnrollmentContainer = (ownProps: BoomEnrollmentContainerProps) => {
  const BoomUserStatus = useSelector(selectBoomUserStatus);
  const selectedProps = useSelector(selectBoomEnrollmentProps);

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  const isBoomEnabled = useSelector(selectIsBoomEnabled);

  if (isBoomEnabled) {
    if (BoomUserStatus && BoomUserStatus !== BoomUserStatuses.OFF) {
      return <Redirect to={RoutesRedirectionFactory.getBoomRoutePathname()} />;
    }

    return <BoomEnrollment {...enhancedProps} />;
  }

  return <Redirect to={RoutesRedirectionFactory.getHomeRoutePathname()} />;
};

export default BoomEnrollmentContainer;
